export default {
  0: '0',
  1: '0.2',
  2: '10',
};
